<template>
  <div class="authorized-account-container">
    <div class="authorized-account-page">
      <!-- 顶部控制区：搜索框 & 分页 -->
      <div class="top-controls">
        <!-- 左侧搜索框 -->
        <el-input v-model="searchQuery" placeholder="搜索授权账号" clearable class="search-input"
          @keyup.enter="handleSearch"></el-input>
        <!-- 右侧分页控件 -->
        <el-pagination class="pagination" background layout="prev, pager, next" :total="total" :page-size="pageSize"
          :current-page="currentPage" @current-change="handlePageChange"></el-pagination>
      </div>

      <!-- 按钮区域 -->
      <div class="auth-buttons">
        <el-button class="task-button book-auth-button" type="primary" :loading="qrLoading" @click="handleSomeBookAuth">
          某书授权
        </el-button>
        <!-- 如需要可启用某手授权按钮 -->
        <!--
        <el-button
          class="task-button hand-auth-button"
          type="primary"
          :loading="qrLoading"
          @click="handleSomeHandAuth"
        >
          某手授权
        </el-button>
        -->
      </div>

      <!-- 表格列表区域：使用骨架屏包裹 -->
      <el-skeleton :loading="loadingData" animated>
        <template #template>
          <div class="table-skeleton">
            <div v-for="n in 8" :key="n" class="skeleton-row">
              <el-skeleton-item variant="text" style="width: 30px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 80px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 80px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 100px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 50px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 120px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 60px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 60px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 100px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 100px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 100px; height: 20px;"></el-skeleton-item>
              <el-skeleton-item variant="text" style="width: 120px; height: 20px;"></el-skeleton-item>
            </div>
          </div>
        </template>
        <template #default>
          <table class="accounts-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>分组ID</th>
                <th>账号类型</th>
                <th>昵称</th>
                <th>头像</th>
                <th>账号</th>
                <th>关注数</th>
                <th>粉丝数</th>
                <th>获赞与收藏</th>
                <th>更新时间</th>
                <th>创建时间</th>
                <th>操作栏</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(account, index) in accounts" :key="account.id">
                <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                <td>{{ account.group_id }}</td>
                <td>{{ account.type_name }}</td>
                <td>{{ account.nickname }}</td>
                <td>
                  <img :src="account.avatar" alt="头像" class="avatar-img" />
                </td>
                <td>{{ account.account }}</td>
                <td>{{ account.following_count }}</td>
                <td>{{ account.followers_count }}</td>
                <td>{{ account.likes_and_collects_count }}</td>
                <td>{{ account.update_time }}</td>
                <td>{{ account.create_time }}</td>
                <td>
                  <el-button class="relogin-button" size="small" :loading="qrLoading" @click="handleSomeBookAuth">
                    重登
                  </el-button>
                  <el-button class="delete-button" size="small" @click="handleDelete(account)">
                    删除
                  </el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </el-skeleton>
    </div>

    <!-- 二维码模态框 -->
    <el-dialog v-model="showQrModal" title="扫码授权" width="400px" :close-on-click-modal="false" :show-close="false">
      <div class="qr-header">
        <span>二维码有效期：{{ formattedCountdown }}</span>
      </div>
      <div class="qr-content">
        <el-skeleton :loading="qrLoading" animated>
          <template #template>
            <div class="qr-skeleton">二维码获取中...</div>
          </template>
          <template #default>
            <img v-if="qrBase64" :src="'data:image/png;base64,' + qrBase64" alt="二维码" class="qr-img" />
          </template>
        </el-skeleton>
      </div>
      <div class="qr-footer">
        <el-button type="primary" :loading="qrLoading" @click="confirmScan">
          已确定扫码
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ElInput, ElButton, ElPagination, ElMessage,
  ElSkeleton, ElSkeletonItem, ElDialog, ElMessageBox
} from "element-plus";
import axios from "axios";
import config from "@/config.js";

export default {
  name: "AuthorizedAccount",
  components: {
    ElInput,
    ElButton,
    ElPagination,
    ElSkeleton,
    ElSkeletonItem,
    ElDialog,
  },
  data() {
    return {
      searchQuery: "",
      currentPage: 1,
      pageSize: 15,
      total: 0,
      loadingData: true,
      accounts: [],
      // 二维码相关数据
      showQrModal: false,
      qrBase64: "",
      webId: "",
      qrLoading: false,  // 二维码加载状态
      countdown: 300, // 5分钟倒计时，单位秒
      countdownTimer: null,
    };
  },
  computed: {
    filteredAccounts() {
      if (!this.searchQuery) return this.accounts;
      return this.accounts.filter(
        account =>
          account.nickname.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          account.account.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    // 这里接口返回分页数据，直接使用 accounts
    paginatedAccounts() {
      return this.accounts;
    },
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (this.countdown % 60).toString().padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
  },
  mounted() {
    const user = localStorage.getItem("user");
    if (!user) {
      this.$router.push({ name: "LoginPage" });
    } else {
      this.fetchAccounts();
    }
  },
  methods: {
    fetchAccounts() {
      const userId = this.$store.state.userId;
      const action = this.searchQuery ? "search" : "query";
      const params = {
        action,
        user_id: userId,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.searchQuery) {
        params.nickname = this.searchQuery;
      }
      axios
        .get(`${config.BASE_URL}/pc/api/auth_user_api.php`, { params })
        .then((res) => {
          if (res.data.success) {
            this.accounts = res.data.data;
            this.total = res.data.total;
          } else {
            ElMessage.error(res.data.error || "接口返回错误");
          }
        })
        .catch((err) => {
          console.error("接口调用失败", err);
          ElMessage.error("接口调用失败");
        })
        .finally(() => {
          // 模拟骨架屏 3 秒延迟
          setTimeout(() => {
            this.loadingData = false;
          }, 500);
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadingData = true;
      this.fetchAccounts();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.loadingData = true;
      this.fetchAccounts();
    },
    handleSomeBookAuth() {
      if (this.qrLoading) return;
      this.qrLoading = true;
      const userId = this.$store.state.userId;
      // 立即显示弹窗，显示骨架屏效果
      this.showQrModal = true;
      axios
        .post(`${config.BASE_URL}/pc/api/xhs_qr.php`, { user_id: userId })
        .then((res) => {
          if (res.data.status === "success") {
            this.webId = res.data.web_id;
            this.qrBase64 = res.data.base64;
            // 成功后启动倒计时
            this.countdown = 300;
            this.startCountdown();
          } else {
            ElMessage.error("获取二维码失败");
          }
        })
        .catch((err) => {
          console.error("获取二维码失败", err);
          ElMessage.error("获取二维码失败");
        })
        .finally(() => {
          this.qrLoading = false;
        });
    },
    handleSomeHandAuth() {
      ElMessage.success("某手授权操作");
    },
    handleRelogin(account) {
      ElMessage.success(`重登账号 ${account.account}`);
    },
    handleDelete(account) {
      ElMessageBox.confirm(
        `确定删除任务 ${account.account} 吗？`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          const userId = this.$store.state.userId;
          axios
            .get(`${config.BASE_URL}/pc/api/auth_user_api.php`, {
              params: { action: "delete", id: account.id, user_id: userId },
            })
            .then((res) => {
              if (res.data.success) {
                ElMessage.success(`删除账号 ${account.account} 成功`);
                this.fetchAccounts();
              } else {
                ElMessage.error(res.data.error || "删除失败");
              }
            })
            .catch((err) => {
              console.error("删除请求失败", err);
              ElMessage.error("删除请求失败");
            });
        })
        .catch(() => {
          ElMessage.info("已取消删除");
        });
    },

    startCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
          // 倒计时结束后自动刷新二维码
          this.handleSomeBookAuth();
        }
      }, 1000);
    },
    confirmScan() {
      if (this.qrLoading) return;
      const userId = this.$store.state.userId;
      // 设置按钮 loading，防止重复点击
      this.qrLoading = true;
      axios
        .post(`${config.BASE_URL}/pc/api/xhs_cookies.php`, { user_id: userId, web_id: this.webId })
        .then((res) => {
          if (res.data.status === "success") {
            ElMessage.success("扫码确认成功");
            this.closeQrModal();
            // 重新获取数据
            this.fetchAccounts();
          } else {
            ElMessage.error("扫码确认失败");
          }
        })
        .catch((err) => {
          console.error("扫码确认接口失败", err);
          ElMessage.error("扫码确认接口失败");
        })
        .finally(() => {
          this.qrLoading = false;
        });
    },

    closeQrModal() {
      this.showQrModal = false;
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    },
  },
};
</script>

<style scoped>
.authorized-account-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.authorized-account-page {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* 顶部控制区 */
.top-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-input {
  width: 300px;
}

.pagination {
  margin-left: auto;
}

/* 按钮区 */
.auth-buttons {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

.task-button {
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 8px;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.task-button:hover {
  transform: scale(1.05);
}

.book-auth-button {
  background: linear-gradient(135deg, #ff7e5f, #feb47b);
  border: none;
  color: #fff;
  height: 40px;
}

.image-text-task-button {
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  border: none;
  color: #fff;
  height: 40px;
}

/* 骨架屏区域 */
.table-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.skeleton-row {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 5px;
}

/* 表格列表区域 */
.accounts-table {
  width: 100%;
  border-collapse: collapse;
}

.accounts-table th,
.accounts-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.accounts-table th {
  background-color: #f2f2f2;
}

.ellipsis {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

/* 操作栏按钮美化 */
.relogin-button {
  background: linear-gradient(135deg, #5cb85c, #4cae4c);
  border: none;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  transition: transform 0.3s ease, background 0.3s ease;
  margin-right: 5px;
}

.relogin-button:hover {
  transform: scale(1.05);
  background: linear-gradient(135deg, #4cae4c, #5cb85c);
}

.delete-button {
  background: linear-gradient(135deg, #ff4d4f, #f5222d);
  border: none;
  border-radius: 4px;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  transition: transform 0.3s ease, background 0.3s ease;
}

.delete-button:hover {
  transform: scale(1.05);
  background: linear-gradient(135deg, #f5222d, #ff4d4f);
}

/* 二维码模态框 */
.el-dialog {
  text-align: center;
}

.qr-header {
  font-size: 16px;
  margin-bottom: 10px;
}

.qr-content {
  margin: 20px 0;
}

.qr-skeleton {
  font-size: 18px;
  color: #999;
  padding: 40px 0;
}

.qr-img {
  max-width: 100%;
  height: auto;
}

.qr-footer {
  margin-top: 20px;
}
</style>
